import { render, staticRenderFns } from "./VentasPorPeriodo.vue?vue&type=template&id=0fa612a0&"
import script from "./VentasPorPeriodo.vue?vue&type=script&lang=js&"
export * from "./VentasPorPeriodo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports